import Client from 'shopify-buy';

const domain = process.env.REACT_APP_SHOPIFY_DOMAIN || 'kodutara.myshopify.com';
const storefrontAccessToken = process.env.REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN || 'acb4ee59c61df30b25b56d5a28d3b29f';

let client = null;
try {
  client = Client.buildClient({
    domain,
    storefrontAccessToken
  });
} catch (error) {
  console.warn('Shopify client initialization error:', error);
}

export default client;
